const REM = {
  SM: '12px',
  MD: '16px',
  LG: '18px',
  XL: '24px',
};

export default REM;
